import { Route, Routes } from "react-router-dom";
import { Initializer } from "../layouts/Initializer";
import { MatchMaker } from "../layouts/MatchMaker";
import AuthProvider from "../contexts/auth.context";
import { ErrorPage } from "../pages/ErrorPage";
import { ContinuePage } from "../pages/ContinuePage";

export const GeneralRoutes = () => {
    return (
        <Routes>
            {/* TAN Authentication route - NOT wrapped in AuthProvider */}
            <Route path="/continue" element={<ContinuePage />} />
            
            {/* All other routes wrapped in AuthProvider */}
            <Route
                element={
                    <AuthProvider>
                        <Initializer />
                    </AuthProvider>
                }
            >
                <Route path="*" element={<MatchMaker />} />
                <Route path="/error-page" element={<ErrorPage />} />
            </Route>
        </Routes>
    );
};
